import { ApiController, CategoryEndPoint } from 'config';
import {
  ICategory,
  ISubcategory,
} from 'redux/modules/Categories/categoriesTypes';
import { get } from '..';

export const getCategories = async () => {
  const response = await get<ICategory[]>({
    url: `/${ApiController.category}`,
  });

  return response;
};

export const getSubcategoriesByCategoryId = async (categoryId: number) => {
  const response = await get<ISubcategory[]>({
    url: `/${ApiController.category}/${categoryId}/${CategoryEndPoint.subcategories}`,
  });

  return response;
};
